import { parse } from 'graphql/language/parser';
import { print } from 'graphql/language/printer';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { explorerRouteConfig } from 'src/app/graph/routes';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const ExplorerLink = ({
  graphId,
  graphVariant,
  document,
  variables,
  className,
  children,
  graphVisibilityType = 'graph',
  label = 'Link URL may be too long for some browsers',
  shouldOpenInNewTab,
}: {
  graphId: string;
  graphVariant: string;
  document: string;
  variables?: string;
  className?: string;
  children?: React.ReactNode;
  graphVisibilityType?: 'graph' | 'public';
  label?: string;
  shouldOpenInNewTab?: boolean;
}) => {
  let explorerDocument: string;
  try {
    explorerDocument = print(parse(document));
  } catch {
    explorerDocument = document;
  }
  const destinationPath = useMemo(() => {
    return explorerRouteConfig.path({
      graphId,
      graphVariant,
      document: explorerDocument,
      variables,
      graphVisibilityType,
    });
  }, [explorerDocument, graphId, graphVariant, graphVisibilityType, variables]);
  return (
    <Tooltip
      label={label}
      // looks like browsers we support can handle 100k+ characters, even if it doesn't display them
      // https://stackoverflow.com/a/812962/482053
      disabled={destinationPath.length > 100000}
    >
      <Link
        to={destinationPath}
        className={className}
        target={shouldOpenInNewTab ? '_blank' : undefined}
      >
        {children}
      </Link>
    </Tooltip>
  );
};
